module.exports = __webpack_public_path__ + "img/28_15.10f65094.png";